// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Cms from "../../../../../../packages/models/Cms.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function Contact(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const country = Buhta_landing__Route.getCountry(undefined);
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const requisites = match[0].requisites;
  let requisite;
  try {
    requisite = Stdlib__List.find((function (r) {
      return r.country === Buhta_models__Locale.toCountryString(country);
    }), requisites);
  }
  catch (exn){
    requisite = Buhta_models__Cms.Requisites.$$default;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Свяжитесь с нами",
        className: "h4 lg:h2 text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "Мы будем рады ответить на все возникшие у вас вопросы любым удобным способом.",
        className: "paragraph text-black-landing mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "-mt-18",
                src: StaticAsset.src("/static/icons/user-circled.svg")
              }),
              JsxRuntime.jsx("h6", {
                children: "Отдел продаж",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Ответим на любые вопросы, расскажем как работаем и что можем предложить.",
                className: "paragraph text-center text-gray-landing mt-1"
              }),
              JsxRuntime.jsxs("a", {
                children: [
                  "Связаться с нами",
                  JsxRuntime.jsx("img", {
                    className: "inline ml-1",
                    src: StaticAsset.src("/static/icons/forward-blue.svg")
                  })
                ],
                className: "block paragraph cursor-pointer mt-6 link-hover text-primary",
                onClick: (function (param) {
                  Buhta_landing__EventHandlers.scrollToFooter(deviceType);
                })
              })
            ],
            className: "flex w-full lg:w-70 bg-bg rounded-lg p-6 flex-col items-center"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "-mt-18",
                src: StaticAsset.src("/static/icons/tickets-circled.svg")
              }),
              JsxRuntime.jsx("h6", {
                children: "Поддержка и консалтинг",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Если возникли вопросы по работе сервиса, то напишите нам.",
                className: "paragraph text-center text-gray-landing mt-1"
              }),
              JsxRuntime.jsxs("a", {
                children: [
                  "Написать нам",
                  JsxRuntime.jsx("img", {
                    className: "inline ml-1",
                    src: StaticAsset.src("/static/icons/forward-blue.svg")
                  })
                ],
                className: "block paragraph cursor-pointer mt-6 link-hover text-primary",
                href: "mailto:hello@buhta.com"
              })
            ],
            className: "flex w-full lg:w-70 bg-bg rounded-lg p-6 flex-col items-center mt-14 lg:mt-0"
          })
        ],
        className: "block lg:flex justify-between mt-16 lg:mt-20"
      }),
      JsxRuntime.jsx("p", {
        children: "Основное назначение Бухты - сделать работу бизнеса более системной через автоматизацию. Если вы хотите сделать ваш бизнес отлаженной системой - то свяжитесь с нами, мы поможем.",
        className: "paragraph text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("h6", {
        children: "Общий канал связи",
        className: "h6 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsxs("p", {
        children: [
          "Для обращений по самым различным вопросам, не связанным с обслуживанием или использованием платформы - пишите нам на ",
          JsxRuntime.jsx("a", {
            children: "hello@buhta.com",
            className: "text-primary underline",
            href: "mailto:hello@buhta.com"
          })
        ],
        className: "paragraph text-black-landing mt-2"
      }),
      JsxRuntime.jsx("h6", {
        children: "Если любите личные встречи",
        className: "h6 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: "Ждем вас в нашем офисе по адресу: " + requisite.address + ".",
        className: "paragraph text-black-landing mt-2"
      })
    ],
    className: "pt-10 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = Contact;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
